import type { JSX } from 'react';

import { TranslateHtml } from '@change-corgi/core/react/i18n';
import { Image } from '@change-corgi/design-system-legacy/components/media';
import { Box } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';

import changeLogo from 'src/assets/changeorg-logo.png';

import type { PreviewEmailPetitionTitleProps } from '../../../../types';

export function PreviewEmailPetitionTitle({ title, userName }: PreviewEmailPetitionTitleProps): JSX.Element {
	return (
		<Box mb={32}>
			<Box sx={{ textAlign: 'center' }} mb={16}>
				<Image src={changeLogo} alt="change.org" />
			</Box>
			<Text as="p" sx={{ fontFamily: 'Helvetica Neue' }} size="small">
				<TranslateHtml
					value="corgi.petition_update.preview_modal.petition_title"
					replacements={{ userPreferredName: userName, petitionTitle: title }}
				/>
			</Text>
		</Box>
	);
}
